const crudDialogMixin = {
  data() {
    return {
      loading: true,
      items: [],
      editedItem: {},
      defaultItem: {},
      dialog: false,
      editedIndex: -1,
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add' : 'Edit';
    },
  },

  methods: {
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.dialog = true;
    },

    saveItem() {
      this.loading = true;

      setTimeout(() => {
        if (this.editedIndex > -1) {
          // Below line has issue but need to fixed bcoz this will fix issue of deep cloning.
          // this.items[this.editedIndex] = JSON.parse(JSON.stringify(this.editedItem));
          Object.assign(this.items[this.editedIndex], this.editedItem);
        } else {
          this.editedItem.id = this.items.length + 1;
          this.items.push(this.editedItem);
        }
        this.closeDialog();
        this.loading = false;
      }, 1000);
    },

    deleteItem() {
      const index = this.items.indexOf(this.editedItem);

      this.$msgbox({
        title: 'Message',
        type: 'warning',
        message: 'This will permanently delete the record. Continue?',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = 'Deleting...';
            setTimeout(() => {
              done();
              setTimeout(() => {
                this.items.splice(index, 1); // Deleting item here
                instance.confirmButtonLoading = false;
                this.closeDialog();
              }, 300);
            }, 500);
          } else {
            done();
          }
        },
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed',
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete cancelled',
        });
      });
    },

    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
        this.editedIndex = -1;
      });
    },
  },
};

export default crudDialogMixin;
